import { SVGFC } from '@repo/toolkit/types'

const EuroIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_1290_139755)">
        <path
          d="M12 4C7.589 4 4 7.589 4 12C4 16.411 7.589 20 12 20C16.411 20 20 16.411 20 12C20 7.589 16.411 4 12 4ZM12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19Z"
          fill={color}
        />
        <path
          d="M13.718 14.617C13.346 14.871 12.936 15 12.5 15C11.579 15 10.781 14.392 10.348 13.5H12C12.276 13.5 12.5 13.276 12.5 13C12.5 12.724 12.276 12.5 12 12.5H10.042C10.019 12.337 10 12.171 10 12C10 11.829 10.019 11.663 10.042 11.5H12.5C12.776 11.5 13 11.276 13 11C13 10.724 12.776 10.5 12.5 10.5H10.348C10.781 9.608 11.579 9 12.5 9C12.936 9 13.346 9.129 13.718 9.383C13.946 9.538 14.258 9.481 14.413 9.252C14.569 9.024 14.51 8.713 14.282 8.557C13.748 8.193 13.132 8 12.5 8C11.035 8 9.781 9.037 9.26 10.5H8.5C8.224 10.5 8 10.724 8 11C8 11.276 8.224 11.5 8.5 11.5H9.044C9.026 11.666 9 11.829 9 12C9 12.171 9.026 12.334 9.044 12.5H8.5C8.224 12.5 8 12.724 8 13C8 13.276 8.224 13.5 8.5 13.5H9.26C9.781 14.963 11.035 16 12.5 16C13.132 16 13.748 15.807 14.282 15.443C14.51 15.287 14.569 14.976 14.413 14.748C14.258 14.52 13.946 14.462 13.718 14.617Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1290_139755">
          <rect width="16" height="16" fill={color} transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default EuroIcon
